import { UserRolesNames } from 'types/User'

export const RULES = [
  {
    name: 'hideFooter',
    allowedRoles: [UserRolesNames.ADMIN],
  },
]
